import { useEffect } from 'react';
import { useOverlayContext } from '../OverlayProvider';

export const useOverlay = (
  overlayName: string,
  open: boolean,
  setOpen: (payload: boolean) => void,
) => {
  const {
    addToCurrentlyOpenOverlays,
    removeFromCurrentlyOpenOverlays,
    isOverlayCurrentlyOpen,
    hideCurrentlyOpenOverlays,
  } = useOverlayContext();

  useEffect(() => {
    if (open) {
      addToCurrentlyOpenOverlays(overlayName);
    }
  }, [open]);

  useEffect(() => {
    if (hideCurrentlyOpenOverlays) {
      setOpen(false);
    } else {
      if (isOverlayCurrentlyOpen(overlayName)) {
        setOpen(true);
      }
    }
  }, [hideCurrentlyOpenOverlays, isOverlayCurrentlyOpen]);

  const handleClose = () => {
    if (open) {
      setOpen(false);
      removeFromCurrentlyOpenOverlays(overlayName);
    }
  };

  const handleToggle = () => {
    if (!open) {
      // if opening
      addToCurrentlyOpenOverlays(overlayName);
    } else {
      // if closing
      removeFromCurrentlyOpenOverlays(overlayName);
    }
  };

  return { handleClose, handleToggle };
};

export default useOverlay;
